import React, { useState, useEffect } from 'react';
import { Button, Col, Row, ModalBody, Form, Spinner } from 'reactstrap';

import * as Yup from 'yup';
import { useFormik } from 'formik';

import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { addNewReportingFrequency, checkReportingFrequencyExists, updateReportingFrequency } from '../../../../../slices/reportingFrequency/thunk';
import { setRequireCloseModal } from '../../../../../slices/reportingFrequency/reducer';
import OInput from '../../../../../Components/OElements/OInput';

const ReportingFrequencyForm = ({
	dataReportingFrequency,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const selectorReportingFrequency = createSelector(
		state => state.ReportingFrequency,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
		})
	);

	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorReportingFrequency);

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: dataReportingFrequency?.name || '',
			disable: dataReportingFrequency?.disable || false,
		},
		validationSchema: Yup.object({
			name: Yup.string()
				.required('Campo requerido')
				.test('name-exists-check', 'Frecuencia de Reportabilidad ya existe', async function (value) {
					if (value && (!isEdit || value !== dataReportingFrequency?.name)) {
						const result = await dispatch(checkReportingFrequencyExists(value));
						if (result.payload.exists) {
							return this.createError({ message: 'Frecuencia de Reportabilidad ya existe' });
						}
					}
					return true;
				}),
		}),
		validateOnChange: false,
		validateOnBlur: true,
		onSubmit: async values => {
			setIsLoading(true);
			const reportingFrequencyData = {
				...values,
				...(isEdit && { _id: dataReportingFrequency._id }),
			};

			if (isEdit) {
				await dispatch(updateReportingFrequency(reportingFrequencyData));
			} else {
				await dispatch(addNewReportingFrequency(reportingFrequencyData));
			}
			setIsLoading(false);
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
				if (toggleRefetch) {
					setTimeout(() => {
						toggleRefetch();
					}, 100);
				}
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (validation.isValid) setIsLoading(true);
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={12}>
						<OInput
							name='name'
							label='Nombre de la Frecuencia de Reportabilidad'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isLoading || isAdding || isUpdating}
					>
						{isLoading || isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : (
							<i className='ri-save-3-line label-icon'></i>
						)}
						{isEdit ? 'Editar' : 'Crear'} Frecuencia de Reportabilidad
					</button>
				</div>
			</div>
		</Form>
	);
};

export default ReportingFrequencyForm;
